import React, { useCallback, useEffect } from 'react';
import Alert from 'fe-design-base/molecules/Alert/Alert';
import Button from 'fe-design-base/molecules/Button';
import { useFormikContext } from 'formik';

import { I18N_PATH } from 'features/team/components/TaxEntryForm/constants';
import { BANNER_VERSION, BUTTON_TEXT } from 'features/teamView/tracking';

import { toI18n } from 'util/i18n';
import { EVENT_ACTIONS, TRACK_ACTION_TYPES } from 'util/tracking_constants';
import { useTrackUx } from 'util/uxEvents';

const ConfirmSuggestedAddressAlert = () => {
  const { setValues, values } = useFormikContext();

  const trackUx = useTrackUx();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.BANNER_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      banner_version: BANNER_VERSION.CONFIRM_SUGGESTED_ADDRESS,
    });
  }, [trackUx]);

  const handleConfirmAddress = useCallback(() => {
    trackUx(EVENT_ACTIONS.BUTTON_CLICKED, TRACK_ACTION_TYPES.CLICK, {
      button_text: BUTTON_TEXT.CONFIRM_ADDRESS,
    });
    setValues({
      ...values,
      address_suggestion_status: 'approved',
      city: values.address_suggestion.city,
      state: values.address_suggestion.state,
      address_1: values.address_suggestion.line1,
      address_2: '',
      zip_code: values.address_suggestion.postal_code,
    });
  }, [setValues, trackUx, values]);

  return (
    <Alert
      variant="info"
      title={toI18n(`${I18N_PATH}.address_alerts.confirm.title`)}
      action={
        <Button variant="secondary" onClick={handleConfirmAddress}>
          {toI18n(`${I18N_PATH}.address_alerts.confirm.cta`)}
        </Button>
      }
    >
      <div>{values.address_suggestion.line1}</div>
      <div>
        {/* eslint-disable-next-line max-len */}
        {`${values.address_suggestion.city}, ${values.address_suggestion.state} ${values.address_suggestion.postal_code}`}
      </div>
    </Alert>
  );
};

export default ConfirmSuggestedAddressAlert;
